export default __webpack_public_path__ + "media/images/mailer/wordmark-3f992cde99d14b59700e095c95521b53.png";